// Detects strings that look like a phone number: digits plus common
// formatting characters (spaces, dashes, dots, brackets, leading +).
const PHONE_LIKE_REGEX = /^[+\d\s().-]+$/;

/**
 * Normalizes a search term before it is sent to the search APIs.
 *
 * Phone-like input (e.g. "+91 97111 13814" pasted from another app) is
 * reduced to bare digits, and the Indian country code ("+91"/"91") or
 * trunk prefix ("0") is dropped. The backend matches with ILIKE %text%,
 * so the 10-digit local number matches rows stored in any format.
 *
 * Non-phone input (names, emails) is only trimmed of outer whitespace so
 * inner spaces (e.g. "John Smith") are preserved.
 */
export const normalizeSearchTerm = (term?: string): string | undefined => {
  if (typeof term !== "string") return term;
  const trimmed = term.trim();
  if (!/\d/.test(trimmed) || !PHONE_LIKE_REGEX.test(trimmed)) {
    return trimmed;
  }
  let digits = trimmed.replace(/\D/g, "");
  if (digits.length === 12 && digits.startsWith("91")) {
    digits = digits.slice(2);
  } else if (digits.length === 11 && digits.startsWith("0")) {
    digits = digits.slice(1);
  }
  return digits;
};
